



interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const aqualyxfat: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "aqualyx-fat-dissolving",
        "meta": {
            "title": "Aqualyx Fat Dissolving Injections in Dubai | Elite Body Home",
            "description": "Non-surgical fat reduction with Aqualyx injections that target stubborn fat in areas like chin, abdomen, thighs without surgery or downtime.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/aqualyx-fat-dissolving/",
            "og": {
                "title": "Aqualyx Fat Dissolving Injections in Dubai | Elite Body Home",
                "description": "Non-invasive fat reduction using Aqualyx injections to dissolve stubborn fat deposits",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Aqualyx-Treatment-Dubai.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Aqualyx Fat Dissolving"],
        "hero": {
            "title": "Aqualyx Fat Dissolving Injections in Dubai",
            "subtitle": "Non-Surgical Fat Reduction",
            "description": "Fat burning treatment Aqualyx is a non-invasive, minimally-invasive to the fat tissue treatment. Aqualyx is a specialized injectable solution that uses an active ingredient to dissolve fat cells in targeted areas of the body, which are then naturally excreted by the body. Non-invasive body sculpting and contouring are beneficial for those patients who would like to mold and perfect their body and prefer to stay away from surgical solutions and/or long recovery times."
        },
        "howItWorks": {
            "title": "What is Aqualyx Fat Burning?",
            "description": "Aqualyx is an injectable fat-dissolving solution used to break down localized fat deposits that are diet and exercise resistant. Aqualyx formula composed of deoxycholic acid works by breaking down fat cell membranes that helps to release and metabolize fat from the body. With its unique technology, it works great in areas that typically retain fat; areas such as the chin, abdomen, thighs and flanks, so it is an excellent choice for body contouring."
        },
        "procedureSteps": {
            "heading": "Highlights of Aqualyx Procedure",
            "para": "The Aqualyx treatment process involves:",
            "steps": [
                {
                    "title": "Non-Invasive",
                    "desc": "A non-invasive procedure to reduce body fat",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Deoxycholic Acid",
                    "desc": "Using deoxycholic acid to dissolve fat cells",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Stubborn Areas",
                    "desc": "Aims areas of stubborn fat that are resistant to exercise",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Quick Recovery",
                    "desc": "Little recovery period and little pain",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Long-Lasting",
                    "desc": "Results that can last with proper care",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Aqualyx Fat Burning Injection Advantages",
            "subheading": "Effective non-surgical fat reduction",
            "para": "Aqualyx offers multiple benefits for body contouring:",
            "items": [
                {
                    "title": "Non-surgical",
                    "desc": "No anesthesia or invasive procedures required",
                    "icon": "fa-solid fa-user-shield"
                },
                {
                    "title": "Targeted fat loss",
                    "desc": "Targets specific problem areas such as the chin, thighs, or abdomen",
                    "icon": "fa-solid fa-crosshairs"
                },
                {
                    "title": "Natural elimination",
                    "desc": "Fat is broken down and excreted through natural body processes",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "Quick recovery",
                    "desc": "Most patients return to normal activities right after the treatment",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Permanent results",
                    "desc": "Destroyed fat cells do not regenerate with proper maintenance",
                    "icon": "fa-solid fa-infinity"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Aqualyx is a very powerful method for fat loss, however it is not for everybody. The ideal candidates are:",
            "items": [
                {
                    "title": "Adults over 18",
                    "desc": "Healthy individuals who do not suffer from serious medical conditions",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "Non-smokers",
                    "desc": "People who don't smoke cigarettes or are willing to quit before treatment",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Stubborn fat",
                    "desc": "Lean but have stubborn fat deposits",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Realistic expectations",
                    "desc": "Know the possible outcomes and process realistic expectations",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation for Aqualyx Fat Burning Injections",
            "subheading": "",
            "para": "How to prepare for your Aqualyx fat burning treatment:",
            "items": [
                {
                    "title": "Consult your provider",
                    "desc": "List any medications, allergies, or health concerns",
                    "icon": "fa-solid fa-notes-medical"
                },
                {
                    "title": "Avoid anti-inflammatories",
                    "desc": "Stop taking aspirin, ibuprofen or blood-thinners a few days before treatment to minimize bruising",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Hydrate",
                    "desc": "Drink a lot of water to facilitate this process in your body",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid alcohol/smoking",
                    "desc": "With realistic expectations in hand understand that, while weight loss injections can be a great part of the total weight loss picture, it's not a magic bullet",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Aqualyx treatment results will develop gradually:",
            "items": [
                {
                    "title": "Gradual improvement",
                    "desc": "Take slowly, a few weeks to remove the fat",
                    "icon": "fa-solid fa-spinner"
                },
                {
                    "title": "Visible in weeks",
                    "desc": "Although results can be seen within a few weeks of starting treatment, the most significant results occur after three months",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Minimal side effects",
                    "desc": "Minor swelling, small lumps, and bruising around the treated area, which may last a few days",
                    "icon": "fa-solid fa-band-aid"
                },
                {
                    "title": "No downtime",
                    "desc": "Little pain and no extensive downtime necessary",
                    "icon": "fa-solid fa-calendar-times"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain your Aqualyx results:",
            "items": [
                {
                    "title": "Massage area",
                    "desc": "Gentle massage can help distribute the solution",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "Stay hydrated",
                    "desc": "Continue drinking plenty of water",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Healthy lifestyle",
                    "desc": "Maintain balanced diet and exercise",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Follow-up sessions",
                    "desc": "Complete all recommended treatments",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long do Aqualyx results last?",
                    "answer": "Aqualyx results are long-lasting as the treated fat cells are permanently destroyed and removed from the body. However, maintaining a healthy lifestyle is crucial to prevent the development of new fat deposits."
                },
                {
                    "question": "How many treatments are needed for optimal results?",
                    "answer": "Typically, patients require 2 to 4 sessions, spaced 3 to 4 weeks apart. The exact number of treatments depends on the area being treated and the amount of fat."
                },
                {
                    "question": "How long does it take to see results from weight loss injections?",
                    "answer": "Results vary, but many patients begin to see noticeable changes within a few weeks after starting treatment, with optimal results after several sessions."
                },
                {
                    "question": "Is the Aqualyx treatment painful?",
                    "answer": "Aqualyx is generally well-tolerated. Some patients may experience mild discomfort, swelling, or bruising at the injection site, but these effects subside within a few days."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/03-Aqualyx-Fat-Burning-Injections-scaled.jpg",
            "beforeAfter": [
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/aqualyx-before-after-1.jpg",
                    "alt": "Aqualyx before and after chin"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/aqualyx-before-after-2.jpg",
                    "alt": "Aqualyx before and after abdomen"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/aqualyx-before-after-3.jpg",
                    "alt": "Aqualyx before and after thighs"
                }
            ]
        },
        "product": {
            "id": 9,
            "title": "Aqualyx Fat Dissolving Injections in Dubai",
            "description": "Non-surgical fat reduction using Aqualyx injections to dissolve stubborn fat in areas like chin, abdomen and thighs.",
            "price": 1500
        }
    },
    "ar": {
        "url": "aqualyx-fat-dissolving",
        "meta": {
            "title": "إبر أكواليكس لإذابة الدهون في دبي | ايليت بودي هوم",
            "description": "علاج غير جراحي لتقليل الدهون العنيدة في مناطق مثل الذقن، البطن، الفخذين باستخدام إبر أكواليكس بدون جراحة أو تعافي طويل.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/aqualyx-fat-dissolving",
            "og": {
                "title": "إبر أكواليكس لإذابة الدهون في دبي | ايليت بودي هوم",
                "description": "علاج غير جراحي لإذابة الدهون العنيدة باستخدام إبر أكواليكس",
                "image": "https://www.elitebodyhome.com/images/aqualyx-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إبر أكواليكس لإذابة الدهون"],
        "hero": {
            "title": "إبر أكواليكس لإذابة الدهون في دبي",
            "subtitle": "تقليل الدهون غير الجراحي",
            "description": "يُعد علاج حرق الدهون باستخدام إبر أكواليكس هو إجراء غير جراحي وأقل تدخلاً لاستهداف الأنسجة الدهنية. تعتمد تقنية أكواليكس على محلول قابل للحقن يحتوي على مكونات فعالة تذيب الخلايا الدهنية في مناطق معينة من الجسم، ليقوم الجسم بعدها بالتخلص منها بشكل طبيعي. توفر إبر التنحيف أكواليكس العديد من الفوائد أهمها نحت الجسم وتحديد القوام بطريقة غير جراحية للأشخاص الذين يرغبون في تحسين شكل أجسامهم دون اللجوء إلى العمليات الجراحية أو تحمل فترات تعافي طويلة."
        },
        "howItWorks": {
            "title": "ما هو علاج أكواليكس لإذابة الدهون؟",
            "description": "أكواليكس هو محلول قابل للحقن مخصص لتفتيت الخلايا الدهنية المتراكمة التي يصعب التخلص منها عبر الأنظمة الغذائية أو التمارين الرياضية. تعتمد تركيبة إبر أكواليكس على حمض الديوكسيكوليك، الذي يعمل على تكسير أغشية الخلايا الدهنية، مما يساعد في تحرر الدهون من الجسم ومن ثم التخلص منها عبر عمليات التمثيل الغذائي الطبيعية. وبفضل تقنيته المتطورة، يُعد أكواليكس خياراً مثالياً لنحت الجسم لمناطق تراكم الدهون الشائعة مثل الذقن، والبطن، والفخذين والجوانب."
        },
        "procedureSteps": {
            "heading": "أبرز مزايا إجراء إذابة الدهون باستخدام إبر أكواليكس",
            "para": "تتميز جلسات أكواليكس بما يلي:",
            "steps": [
                {
                    "title": "غير جراحي",
                    "desc": "إجراء غير جراحي لتقليل الدهون في الجسم",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "حمض الديوكسيكوليك",
                    "desc": "يعتمد على حمض الديوكسيكوليك لإذابة الخلايا الدهنية",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "المناطق العنيدة",
                    "desc": "يستهدف مناطق تراكم الدهون العنيدة التي لا تستجيب للتمارين الرياضية",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "تعافي سريع",
                    "desc": "يوفر فترة تعافٍ قصيرة، كما يمكن أن يسبب ألم طفيف",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "نتائج دائمة",
                    "desc": "يحقق نتائج تدوم طويلاً مع العناية المناسبة",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد إبرة أكواليكس لحرق الدهون",
            "subheading": "تقليل الدهون الفعال بدون جراحة",
            "para": "تقدم أكواليكس العديد من المزايا لنحت الجسم:",
            "items": [
                {
                    "title": "غير جراحي",
                    "desc": "لا يتطلب تخديرًا عامًا أو تدخل جراحي",
                    "icon": "fa-solid fa-user-shield"
                },
                {
                    "title": "استهداف الدهون",
                    "desc": "يستهدف المناطق التي تتراكم بها الدهون مثل الذقن، أو الفخذين، أو البطن",
                    "icon": "fa-solid fa-crosshairs"
                },
                {
                    "title": "إزالة طبيعية",
                    "desc": "يتم تحطيم الدهون وإخراجها من الجسم عبر العمليات الطبيعية",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "تعافي سريع",
                    "desc": "يتمكن المرضى من العودة إلى أنشطتهم اليومية فورًا بعد العلاج",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "نتائج دائمة",
                    "desc": "الخلايا الدهنية المدمرة لا تتجدد مع العناية المناسبة",
                    "icon": "fa-solid fa-infinity"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "تعد إبر أكواليكس طريقة فعالة للغاية لفقدان الدهون، ولكنها لا تناسب الجميع. المرشحون المثاليون هم:",
            "items": [
                {
                    "title": "البالغون فوق 18",
                    "desc": "الأفراد الأصحاء الذين لا يعانون من حالات طبية خطيرة",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "غير المدخنين",
                    "desc": "الأشخاص غير المدخنين أو مستعدون للإقلاع عن التدخين قبل العلاج",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "دهون عنيدة",
                    "desc": "النحيفون لكن يعانون من تراكمات دهنية عنيدة",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "توقعات واقعية",
                    "desc": "معرفة بالنتائج التي يمكن تحقيقها من العلاج، وامتلاك توقعات واقعية",
                    "icon": "fa-solid fa-clipboard-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد لجلسة أكواليكس",
            "subheading": "",
            "para": "كيفية التحضير لجلسة علاج أكواليكس:",
            "items": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "قم بتقديم قائمة بكل الأدوية التي تتناولها، وأي حساسية قد تعاني منها، أو أي مشكلات صحية",
                    "icon": "fa-solid fa-notes-medical"
                },
                {
                    "title": "تجنب مضادات الالتهاب",
                    "desc": "يجب التوقف عن تناول الأسبرين، أو الإيبوبروفين أو مميعات الدم قبل العلاج بعدة أيام، لتقليل فرص حدوث الكدمات",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "ترطيب الجسم",
                    "desc": "اشرب الكثير من الماء لتسهيل عملية التخلص من الدهون في الجسم",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب الكحول/التدخين",
                    "desc": "تأكد من تجنب الكحول أو التدخين قبل العلاج",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "تتطور نتائج علاج أكواليكس تدريجيًا:",
            "items": [
                {
                    "title": "تحسن تدريجي",
                    "desc": "قد يستغرق الجسم بضعة أسابيع لإزالة الدهون تدريجيًا",
                    "icon": "fa-solid fa-spinner"
                },
                {
                    "title": "ظهور النتائج",
                    "desc": "على الرغم من أنه يمكن ملاحظة النتائج خلال بضعة أسابيع من بدء العلاج، إلا أن النتائج الأكثر وضوحًا تظهر بعد ثلاثة أشهر",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "قد يحدث تورم طفيف، أو تظهر نتوءات صغيرة، أو كدمات حول المنطقة المعالجة، والتي قد تستمر لبضعة أيام",
                    "icon": "fa-solid fa-band-aid"
                },
                {
                    "title": "لا حاجة للراحة",
                    "desc": "قد يسبب ألم طفيف، ولكن لا يتطلب فترة تعافي طويلة",
                    "icon": "fa-solid fa-calendar-times"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للحفاظ على نتائج أكواليكس:",
            "items": [
                {
                    "title": "تدليك المنطقة",
                    "desc": "التدليك اللطيف يمكن أن يساعد في توزيع المحلول",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "نمط حياة صحي",
                    "desc": "حافظ على نظام غذائي متوازن وممارسة الرياضة",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "أكمل جميع العلاجات الموصى بها",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم نتائج أكواليكس؟",
                    "answer": "نتائج أكواليكس تدوم طويلاً حيث يتم تدمير الخلايا الدهنية المعالجة وإزالتها بشكل دائم من الجسم. ومع ذلك، فإن الحفاظ على نمط حياة صحي ضروري لمنع تكوين رواسب دهنية جديدة."
                },
                {
                    "question": "كم عدد الجلسات المطلوبة للحصول على أفضل النتائج؟",
                    "answer": "عادة ما يحتاج المرضى إلى 2 إلى 4 جلسات، بفاصل 3 إلى 4 أسابيع. يعتمد العدد الدقيق للجلسات على المنطقة المعالجة وكمية الدهون."
                },
                {
                    "question": "كم من الوقت يستغرق ظهور نتائج إبر إنقاص الوزن؟",
                    "answer": "تختلف النتائج، ولكن العديد من المرضى يبدأون في ملاحظة تغييرات واضحة في غضون بضعة أسابيع بعد بدء العلاج، مع تحقيق النتائج المثلى بعد عدة جلسات."
                },
                {
                    "question": "هل علاج أكواليكس مؤلم؟",
                    "answer": "عادة ما يكون أكواليكس جيد التحمل. قد يعاني بعض المرضى من انزعاج خفيف أو تورم أو كدمات في موقع الحقن، ولكن هذه الآثار تختفي في غضون أيام قليلة."
                }
            ]
        }
    }
}